import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF760A",
  "fill-rule": "evenodd",
  d: "M8.754 13.13a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v3.002a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1zm2 1.001v1h2.5v-1z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#151515",
  "fill-rule": "evenodd",
  d: "M10.361 2.13a3 3 0 0 1 3.286 0l7.749 5.07a3 3 0 0 1 1.358 2.511v12.423a1 1 0 1 1-2 0V9.711a1 1 0 0 0-.454-.837l-7.748-5.069a1 1 0 0 0-1.096 0L3.707 8.874a1 1 0 0 0-.452.837v12.423a1 1 0 1 1-2.001 0V9.711c0-1.013.51-1.957 1.358-2.511z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#151515",
  "fill-rule": "evenodd",
  d: "M5.754 15.131a3 3 0 0 1 3-3h6.5a3 3 0 0 1 3 3v5.003a3 3 0 0 1-3 3h-6.5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v5.003a1 1 0 0 0 1 1h6.5a1 1 0 0 0 1-1V15.13a1 1 0 0 0-1-1z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }